import {createRouter, createWebHistory, type Router} from "vue-router";
import {useCurrentUserStore} from '@/stores/current-user'
import userRoutes from "./user";
import roleRoutes from "./role";
import customerRoutes from "./customer";
import warehouseRoutes from "./warehouse";
import productRoutes from "./product";
import stockRoutes from "./stock";
import compositionRoutes from "./composition";
import productionRoutes from "./production";
import orderRoutes from "./order";
import reportRoutes from "./report";
import expenseRoutes from "./expense";
import authRoutes from "@/routes/auth";
import settingRoutes from "@/routes/setting";
import userLogRoutes from "@/routes/user-log.ts";
import referralRoutes from "@/routes/referral.ts";

export const routes = [
  ...authRoutes,
  {
    path: '/',
    component: () => import('@/layout/DefaultLayout.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('@/views/Dashboard.vue'),
      },
      ...userRoutes,
      ...roleRoutes,
      ...customerRoutes,
      ...warehouseRoutes,
      ...productRoutes,
      ...stockRoutes,
      ...compositionRoutes,
      ...productionRoutes,
      ...orderRoutes,
      ...reportRoutes,
      ...expenseRoutes,
      ...settingRoutes,
      ...userLogRoutes,
      ...referralRoutes,
    ]
  },
];

const router: Router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to) => {
  const userStore = useCurrentUserStore()
  if (!userStore.isLoggedIn && !to.meta?.no_auth) {
    return {name: 'login'}
  }
  if (to.name === 'login' && userStore.isLoggedIn) {
    return {name: 'dashboard'}
  }
})

router.onError((error, to, _) => {
  if (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes("Importing a module script failed")) {
    window.location.reload()
  }
})

export default router;
